import styled from 'styled-components';

import { Text } from '@components/text';
import { pxToRem } from '@utils/converters';

export const FilterSubheading = ({ text }: { text: string }) => {
  return (
    <Container>
      <Text font="bold14" color="textPrimary" text={text} />
    </Container>
  );
};

const Container = styled.div({
  minHeight: pxToRem(40),
  display: 'flex',
  alignItems: 'center',
});
